/**
 * State used in rendering MessageBarBody
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
